import { Customer } from '../models/customer';
import { Job } from '../models/job';
import { JobStatusEnum } from '../models/jobStatusEnum';

export function checkCanCancelJob(job: Job, loggedInCustomer: Customer) {
  return (
    job &&
    job.status != JobStatusEnum.CANCELED &&
    loggedInCustomer &&
    job.customer &&
    loggedInCustomer._id == job.customer.id
  );
}
